import { Sol50OnRoof } from "./Sol50OnRoof";

export class SOL50STANDARD4m {
	constructor(private _Sol50OnRoof: Sol50OnRoof) { }

	public static HProfile_setVar(): void {
	}
	public static HProfile_Stocklist_getString(): string {
		let sRet: string;
		this.HProfile_setVar();
		sRet = "";
		sRet += Sol50OnRoof.sHProfileVar + ":" + Sol50OnRoof.getHProfile() + "|";
		return sRet;
	}
}